export type WordSearchPayloadItem = {
  explanation?: string;
  variants?: string[];
  word?: string;
};

type WordSearchPayloadTranslations = {
  ariaLabel?: string;
  closeLabel?: string;
};

type WordSearchPayload = {
  translations?: WordSearchPayloadTranslations;
  words?: WordSearchPayloadItem[];
};

export type WordSearchData = {
  ariaLabel: string;
  closeLabel: string;
  words: WordSearchPayloadItem[];
};

const wordListScriptId = 'word-search-words';

export const getWordSearchData = (): WordSearchData => {
  const wordListScript = document.getElementById(wordListScriptId);
  const serializedWords = wordListScript?.textContent;

  if (!serializedWords) {
    return {
      ariaLabel: '',
      closeLabel: '',
      words: []
    };
  }

  try {
    const parsedPayload = JSON.parse(serializedWords) as WordSearchPayload | WordSearchPayloadItem[];

    if (Array.isArray(parsedPayload)) {
      return {
        ariaLabel: '',
        closeLabel: '',
        words: parsedPayload
      };
    }

    const words = Array.isArray(parsedPayload?.words)
      ? parsedPayload.words
      : [];
    const translations = parsedPayload?.translations;

    return {
      ariaLabel: typeof translations?.ariaLabel === 'string'
        ? translations.ariaLabel
        : '',
      closeLabel: typeof translations?.closeLabel === 'string'
        ? translations.closeLabel
        : '',
      words: words
    };
  } catch {
    return {
      ariaLabel: '',
      closeLabel: '',
      words: []
    };
  }
};
